export default __webpack_public_path__ + "static/media/haeuser_intro_web-xs@2x.75e3df95.webp";